module.exports = __webpack_public_path__ + "static/terms_of_service-93b192321867845a68b2021fd0ca9933.pdf";